import { render, staticRenderFns } from "./transcribe.vue?vue&type=template&id=654d1219"
import script from "./transcribe.vue?vue&type=script&lang=js"
export * from "./transcribe.vue?vue&type=script&lang=js"
import style0 from "./transcribe.vue?vue&type=style&index=0&id=654d1219&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports